import React from 'react';
import './footer.css';

function Footer() {
  return (
    <div className='portfolio__footer section__padding'>
      {/* <div className='portfolio__footer-heading'>
        <h1 className='gradient__text'>That's really all I have for you here, unless you like old memes.</h1>
      </div>
      <div className='portfolio__footer-btn'>
        <p>Deploy Bobson Dugnutt</p>
      </div> */}
      <div className='portfolio__footer-copyright'> 
        <p>© Charlie Hayes, 2022</p>
      </div>
    </div>
  )
}

export default Footer
